/**
 * Bloc « Santé entreprise » du volet de synthèse CLIENT.
 *
 * Réutilise EXACTEMENT le composant de l'onglet Synthèse de la fiche
 * (`FinancialHealthSummary`) : même jauge (`ScoringGauge`), pastille « Fiable ·
 * N/10 », date de mise à jour, verdict actionable, et bandeau KPIs Ancienneté ·
 * Effectif · CA · Résultat net · Tendance — avec l'icône électrocardiogramme et
 * le titre « Santé entreprise ». Aucune duplication de la logique santé.
 *
 * Chargé PARESSEUSEMENT : le bundle santé financière (BOOST) n'est tiré que
 * lorsqu'un client est épinglé. Le client est refetché par (id, entité) mais la
 * clé React Query est partagée avec la fiche → cache réutilisé (souvent déjà
 * chaud). `FinancialHealthSummary` renvoie `null` pour un PARTICULIER ou sans
 * SIREN (même comportement que la fiche).
 */

import { Suspense, lazy } from 'react'

import { useClientDetail } from '@/hooks/useClients'

const FinancialHealthSummary = lazy(() =>
    import('@/pages/crm/components/synthesis/FinancialHealthSummary').then((m) => ({
        default: m.FinancialHealthSummary,
    })),
)

export function ClientHealthCard({
    clientId,
    entityId,
    compact = false,
    hideKpis = false,
}: {
    clientId: string
    entityId: string | null
    /** Variante compacte (fiche devis) → KPIs sous la jauge, ~50% de hauteur en moins. */
    compact?: boolean
    /** Variante minimale (fiche devis, colonne étroite) → jauge + verdict seuls, sans KPIs. */
    hideKpis?: boolean
}) {
    const { data: client } = useClientDetail(clientId, entityId)
    if (!client) return null
    return (
        <Suspense fallback={null}>
            {/* `dense` : le volet est étroit (~472px) → bandeau KPIs en 2 colonnes
                (jamais de chevauchement de texte). */}
            <FinancialHealthSummary client={client} dense compact={compact} hideKpis={hideKpis} />
        </Suspense>
    )
}
